var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip absolute pointer-events-none",class:{
    'opacity-100 ': _vm.show,
    'opacity-0 ': !_vm.show,
  }},[_c('div',{ref:"slot",staticClass:"tooltip-inner"},[_vm._t("default")],2),_c('div',{ref:"arrow",staticClass:"tooltip-arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }